export type BusinessOccasion = {
  icon: string
  title: string
  text: string
  href: string
}

/**
 * Shared data for the Business hub landing grid and the site Footer.
 * Kept in a plain module (not `'use client'`) so Server Components like the
 * Footer can import the real array rather than a client-reference proxy.
 */
export const businessOccasions: BusinessOccasion[] = [
  {
    icon: '🏆',
    title: 'Employee Recognition',
    text: 'Celebrate outstanding work the moment it happens.',
    href: '/business/occasions/employee-recognition',
  },
  {
    icon: '🎂',
    title: 'Employee Birthday',
    text: 'Make every birthday feel like a team event.',
    href: '/business/occasions/employee-birthday',
  },
  {
    icon: '📅',
    title: 'Work Anniversary',
    text: 'Honor years of dedication with a wall that grows with them.',
    href: '/business/occasions/work-anniversary',
  },
  {
    icon: '🚀',
    title: 'Promotion',
    text: 'Mark career milestones with company-wide appreciation.',
    href: '/business/occasions/promotion',
  },
  {
    icon: '👋',
    title: 'Farewell',
    text: 'Send departing teammates off with heartfelt memories.',
    href: '/business/occasions/farewell',
  },
  {
    icon: '🎉',
    title: 'Retirement',
    text: 'Create a lasting keepsake for a career well spent.',
    href: '/business/occasions/retirement',
  },
  {
    icon: '🥇',
    title: 'Team Achievement',
    text: 'Celebrate wins, launches, and project milestones together.',
    href: '/business/occasions/team-achievement',
  },
  {
    icon: '🏢',
    title: 'Company Milestone',
    text: 'Mark anniversaries and business growth as one team.',
    href: '/business/occasions/company-milestone',
  },
]
